export default __webpack_public_path__ + "dbdee6a7596fbb6dd7a74c7eb7bbd860.png";